<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" @change="handleChange">
                <a-select-option v-for="(item, index) in changelogStatus" :key="index" :value="item.value"> <a-badge :color="item.color" :text="item.label" /> </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getChangelogList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="更新日志" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-has="{ code: 'system:changelog:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handlePageChange">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:changelog:detail', project: 0 }" @click="onPreview(record)">预览</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:changelog:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:changelog:delete', project: 0 }" @click="onDelete(record)">删除</a>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :color="changelogStatus[record.status].color" :text="changelogStatus[record.status].label" />
        </span>
      </a-table>
      <changelog-drawer :visible="drawerVisible" :changelog-id="changelogId" @close="close" @cancel="cancel" />
      <changelog-modal :is-show="modalVisible" :changelog-id="changelogId" @close="close" @cancel="cancel" />
    </a-card>
  </div>
</template>

<script>
import { changelogList, changelogDelete } from '@/api/system/about';
import { changelogStatus } from '@/utils/dictionary';
import ChangelogDrawer from '@/pages/system/components/ChangelogDrawer';
import ChangelogModal from '@/pages/system/components/ChangelogModal';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    align: 'center',
    width: 80
  },
  {
    title: '版本号',
    key: 'version',
    dataIndex: 'version',
    width: 200,
    align: 'center'
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '发布时间',
    dataIndex: 'release_time',
    key: 'release_time',
    align: 'center',
    width: 200
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    ChangelogDrawer,
    ChangelogModal
  },
  data() {
    return {
      filterForm: {
        status: null,
        page_size: 10,
        page_number: 1
      },
      changelogId: null,
      drawerVisible: false,
      modalVisible: false,
      loading: false,
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      changelogStatus,
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  mounted() {
    this.getChangelogList();
  },
  methods: {
    handleChange() {
      this.pagination.current = 1;
      this.getChangelogList();
    },

    // 点击添加
    onAdd() {
      this.changelogId = null;
      this.drawerVisible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.changelogId = record.id;
      this.drawerVisible = true;
    },

    // 点击预览
    onPreview(record) {
      this.changelogId = record.id;
      this.modalVisible = true;
    },

    // 点击重置
    onReset() {
      this.filterForm = {
        name: null,
        changelog_type: null,
        project_id: null
      };
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getChangelogList();
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取更新日志列表
    getChangelogList() {
      this.loading = true;
      changelogList({ ...this.filterForm, page_number: this.pagination.current, page_size: this.pagination.pageSize })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 删除更新日志
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该更新日志吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          const { code, message } = await changelogDelete({ changelog_id: record.id });
          if (code === 2000) {
            self.$message.success('删除成功');
            self.getChangelogList();
          } else {
            self.$message.warning(message);
          }
        }
      });
    },

    // 操作页面变更
    handlePageChange(pagination) {
      this.pagination = pagination;
      this.getChangelogList();
    },

    // 关闭弹窗
    close() {
      this.drawerVisible = false;
      this.modalVisible = false;
      this.changelogId = null;
      this.getChangelogList();
    },

    cancel() {
      this.drawerVisible = false;
      this.modalVisible = false;
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
